import {Component, Input, OnInit} from '@angular/core';
import {Container, Filter, VoceSpedizione} from "../_Models";
import {Subscription} from "rxjs";
import {ClassicType} from "../../shared/models/ClassicType";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {NgbModal, NgbPopover} from "@ng-bootstrap/ng-bootstrap";
import {ServerPaginationService} from "../../shared/_services/server-pagination.service";
import {Permission} from "../../Login/_guards/Permission";
import {ApiRestService} from "../api-rest.service";
import {ContainerEditComponent} from "../container-edit/container-edit.component";

@Component({
  selector: 'app-container-list',
  templateUrl: './container-list.component.html'
})
export class ContainerListComponent implements OnInit {
  subscriptions: Subscription = new Subscription();
  page = 1;
  pageSize = 50;
  pagesizeserver = 4
  newpagegenerated = 1;
  List: Container[] = [];
  collectionSize: number = 0;
  Stati: ClassicType[];
  StatiSelezionati: ClassicType[] = [{id: "TC", label: "Tutti"}] ;
  DropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField:'id',
    textField: 'label'
  };
  @Input() hasFiltri: boolean = true;
  @Input() isAddEnabled: boolean = true;
  @Input() isEditEnabled: boolean = true;
  @Input() Filtri: Filter = {page: 1, size: 10, stato: "TC", periodo: false};
  SelectAll: boolean;
  stampe: any[];
  listaPopup: VoceSpedizione[];
  constructor(
    private modalService: NgbModal,
    private paginationService: ServerPaginationService,
    public permission: Permission,
    private apirestservice: ApiRestService,
  ) { }

  ngOnInit(): void {
    this.refreshTable(1);
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }
  refreshTable(page: number) {
    if(this.Filtri?.inizio && !this.Filtri?.fine)
      this.Filtri.fine = this.Filtri?.inizio;
    this.apirestservice.PrimaNotaContainerStati().subscribe(data=> this.Stati = data ?? [])
    this.Filtri.size = this.pagesizeserver * this.pageSize;
    this.Filtri.page = (page - 1) / this.pagesizeserver + 1;
    this.Filtri.stato = this.StatiSelezionati?.length > 0 ? this.StatiSelezionati[0]?.id: "TS";
    this.apirestservice.PrimaNotaContainerList(this.Filtri).subscribe(data=>{
      this.collectionSize = data?.total;
      this.List = data?.data;
      this.stampe = data?.stampe;
    });
  }
  Edit(item?: Container) {
    let modale = this.modalService.open(ContainerEditComponent,{
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<ContainerEditComponent>modale.componentInstance).isModal = true;
    (<ContainerEditComponent>modale.componentInstance).item = item ?? new Container();
    (<ContainerEditComponent>modale.componentInstance).Saved.subscribe(()=> this.refreshTable(1));
  }
  delete(item: Container) {
    if (confirm("Sei sicuro di voler eliminare questo elemento?")) {
       this.apirestservice.PrimaNotaContainerDelete(item).subscribe(() => this.refreshTable(this.newpagegenerated));
    }
  }
  CheckIfAllSelected() {
    this.SelectAll = this.List.every(function (item: any) {
      return item.isSelected == true;
    })
  }
  checkUncheckAll() {
    this.List?.forEach(item => item.isSelected = this.SelectAll)
  }

  ViewProd(item: Container, p1: NgbPopover) {
    p1.open();
    this.listaPopup = [];
    this.apirestservice.PrimaNotaContainerGet(item).subscribe(data => {
     this.listaPopup = data.voci
    })
  }
}
